export const NotoSansJp = {
    fontFamily:"'Noto Sans JP',Sans-serif",
    lineHeight:"1.8em",
    letterSpacing:"2px"
};

export const QuickSand = {
    fontFamily:"'Quicksand',Sans-serif",
    lineHeight:"1.8em",
    letterSpacing:"2px"
}
